(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[628],{

/***/ 9850:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseClone = __webpack_require__(18874);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

module.exports = cloneDeep;


/***/ }),

/***/ 68762:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...id]",
      function () {
        return __webpack_require__(32948);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 32948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _id_; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/lib/Hydrate.mjs
var Hydrate = __webpack_require__(55464);
// EXTERNAL MODULE: ../../node_modules/next-urql/dist/next-urql.es.js + 1 modules
var next_urql_es = __webpack_require__(38002);
// EXTERNAL MODULE: ../../node_modules/urql/dist/urql.es.js
var urql_es = __webpack_require__(26806);
// EXTERNAL MODULE: ./src/components/app/layout/index.tsx + 110 modules
var layout = __webpack_require__(37356);
// EXTERNAL MODULE: ./src/components/content/page.tsx
var page = __webpack_require__(79803);
// EXTERNAL MODULE: ./src/components/content/stitches.ts
var stitches = __webpack_require__(65465);
;// CONCATENATED MODULE: ./src/components/no-route/no-route.tsx


var NoRoute = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: "Not found"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "We couldn't find what you were looking for"
            })
        ]
    });
};
var Container = (0,stitches/* styled */.zo)("div", {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    height: "calc(100vh - var(--size-20))",
    justifyContent: "center",
    gap: "var(--size-2)",
    textAlign: "center",
    width: "100%",
    "h1, p": {
        margin: 0
    }
});

// EXTERNAL MODULE: ./src/services/content.service.ts + 1 modules
var content_service = __webpack_require__(44973);
// EXTERNAL MODULE: ./src/types/graphql-schema.ts
var graphql_schema = __webpack_require__(91021);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(32210);
;// CONCATENATED MODULE: ./pages/[...id].tsx











function Page(param) {
    var _slug = param.slug, slug = _slug === void 0 ? "" : _slug, serverState = param.serverState;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,urql_es/* useQuery */.aM)({
        query: graphql_schema/* PageQueryDocument */.HO,
        variables: {
            slug: slug
        }
    }), 1), data = ref6[0].data;
    var hasPages = Boolean(data === null || data === void 0 ? void 0 : (ref = data.pages) === null || ref === void 0 ? void 0 : ref.length);
    if (!hasPages) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Hydrate/* Hydrate */.p, {
            state: serverState,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoRoute, {})
            })
        });
    }
    var _id, _seoTitle, _seoDescription, _seoImage;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Hydrate/* Hydrate */.p, {
        state: serverState,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(page/* Page */.T, {
            id: (_id = data === null || data === void 0 ? void 0 : (ref1 = data.pages) === null || ref1 === void 0 ? void 0 : ref1[0].id) !== null && _id !== void 0 ? _id : "",
            seoTitle: (_seoTitle = data === null || data === void 0 ? void 0 : (ref2 = data.pages) === null || ref2 === void 0 ? void 0 : ref2[0].seoTitle) !== null && _seoTitle !== void 0 ? _seoTitle : "",
            seoDescription: (_seoDescription = data === null || data === void 0 ? void 0 : (ref3 = data.pages) === null || ref3 === void 0 ? void 0 : ref3[0].seoDescription) !== null && _seoDescription !== void 0 ? _seoDescription : "",
            seoImage: (_seoImage = data === null || data === void 0 ? void 0 : (ref4 = data.pages) === null || ref4 === void 0 ? void 0 : ref4[0].seoImage) !== null && _seoImage !== void 0 ? _seoImage : "",
            content: data === null || data === void 0 ? void 0 : (ref5 = data.pages) === null || ref5 === void 0 ? void 0 : ref5[0].content
        })
    });
}
var __N_SSP = true;
/* harmony default export */ var _id_ = ((0,next_urql_es/* withUrqlClient */.X)(function(ssrExchange, ctx) {
    var ref;
    var meta = undefined;
    if (true) {
        meta = (0,utils/* getRequestOrigin */.vi)(window.location.host);
    } else {}
    return (0,content_service/* contentSetupAPIRequests */.XG)(ssrExchange, meta);
}, {
    neverSuspend: true
})(Page));


/***/ }),

/***/ 39916:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ MagicBoxParams; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90581);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64297);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58408);
/* harmony import */ var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9850);
/* harmony import */ var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72579);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_1__);





var MagicBox = /*#__PURE__*/ function() {
    "use strict";
    function MagicBox() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, MagicBox);
    }
    /**
   * Flatten an object and get paths to all its properties
   *
   * @param object
   * @param path
   * @param paths
   * @returns {*}
   * @TODO improve typing of `object` and `paths`.
   */ MagicBox.flatten = function flatten(object, path, paths) {
        for(var key in object){
            if (object.hasOwnProperty(key)) {
                if (typeof object[key] === "object") {
                    MagicBox.flatten(object[key], "".concat(path, ".").concat(key), paths);
                } else if (path !== "") {
                    paths[key] = "".concat(path.slice(1), ".").concat(key);
                } else {
                    paths[key] = key;
                }
            }
        }
        return paths;
    };
    /**
   * Build arbitrarily nested filters
   *
   * @param filters
   * @param key
   * @returns {Array}
   * @TODO improve typing of `filters`.
   */ MagicBox.buildFilters = function buildFilters(filters, key) {
        // Flatten the filters object to retrieve an object of {column_name: 'path.in.original.object'
        var flattened = MagicBox.flatten(filters, "", {});
        var filterStrings = [];
        for(var column in flattened){
            if (flattened.hasOwnProperty(column)) {
                // Remove column name from path, replace ORs and ANDs
                var orString = flattened[column].toLowerCase().replace(column, "").replace(/or\./g, "[or]").replace(/and\./g, "[and]");
                // Find the filter's value by the retrieved path
                var filter = orString.length === 0 ? filters[column] : lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(filters, flattened[column].replace(column, ""))[column];
                // Build the query param part
                filterStrings.push("".concat(key + orString, "[").concat(column, "]=").concat(filter));
            }
        }
        return filterStrings;
    };
    /**
   * Build a query string (of modifiers) such as per_page, filter, etc
   *
   * Modifiers can look like:
   * const modifiers = {
   * 		filters: {
   * 		    foo: '=bar',
   * 		    or : {
   * 		        baz            : 'bat',
   * 		        'relation.attr': '[1,2,3]'
   * 		    }
   * 		},
   * 		sort   : {
   * 		    'foo': 'asc'
   * 		},
   * 		include: [
   * 		    'foo.bar',
   * 		    'baz.bat',
   * 		]
   * 	};
   *
   * @param {object} modifiers
   * @returns {string}
   * @TODO improve the typing of `modifiers`.
   */ MagicBox.buildUrlModifiers = function buildUrlModifiers(modifiers) {
        var _loop = function(key) {
            // Handle filters and sorts as php assoc. arrays ['key' => 'value']
            if (key === "filters") {
                parts = parts.concat(MagicBox.buildFilters(modifiers[key], key));
            } else if (key === "sort" || key === "aggregate") {
                var part = modifiers[key];
                for(var column in part){
                    if (part.hasOwnProperty(column)) {
                        parts.push("".concat(key, "[").concat(column, "]=").concat(part[column]));
                    }
                }
            } else if (key === "include") {
                // @ts-expect-error
                modifiers[key].forEach(function(relation) {
                    parts.push("include[]=".concat(relation));
                });
            } else {
                // Handle others as objects to be serialized
                parts.push(MagicBox.serialize(modifiers[key]));
            }
        };
        var parts = [];
        for(var key in modifiers)_loop(key);
        if (parts.length > 0) {
            return parts.join("&");
        }
        return "";
    };
    /**
   * Serialize an object into a string of query parameters. This does not return the beginning ?.
   *
   * @param object
   * @returns {string}
   */ MagicBox.serialize = function serialize(object) {
        var parts = [];
        for(var param in object){
            if (object.hasOwnProperty(param)) {
                parts.push("".concat(encodeURIComponent(param), "=").concat(encodeURIComponent(object[param])));
            }
        }
        return parts.join("&");
    };
    /**
   * Break apart a query string into an object
   *
   * @param queryString
   * @returns {{}}
   */ MagicBox.deserialize = function deserialize(queryString) {
        var pairs = queryString.split("&");
        var params = {};
        pairs.forEach(function(pair) {
            var p = pair.split("=");
            params[p[0]] = decodeURIComponent(pair[1] || "");
        });
        return params;
    };
    return MagicBox;
}();
/**
 * A MagicContainer clones itself to prevent weird javascript stuff
 */ var MagicContainer = /*#__PURE__*/ function() {
    "use strict";
    function MagicContainer() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, MagicContainer);
    }
    var _proto = MagicContainer.prototype;
    _proto.clone = function clone() {
        return lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_0___default()(this);
    };
    return MagicContainer;
}();
/**
 * MagicBoxParams is a container for filters, includes, sorts, pagination which get
 * passed to a MagicBox API.
 */ var MagicBoxParams = /*#__PURE__*/ function(MagicContainer) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(MagicBoxParams, MagicContainer);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(MagicBoxParams);
    function MagicBoxParams(filters, sort, include, page, perPage) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, MagicBoxParams);
        var _this;
        _this = _super.call(this);
        _this.without_pagination = false;
        _this.filters = filters || {};
        _this.sort = sort || {};
        _this.include = include || [];
        _this.page = page || 1;
        _this.per_page = perPage || 20;
        return _this;
    }
    var _proto = MagicBoxParams.prototype;
    /**
   * Get the modifier object
   *
   * @returns {object}
   */ _proto.modifiers = function modifiers() {
        return Object.assign({}, {
            filters: this.filters,
            sort: this.sort,
            include: this.include
        });
    };
    /**
   * Get the query for the modifier params
   *
   * @returns {string}
   */ _proto.modifierQuery = function modifierQuery() {
        return MagicBox.buildUrlModifiers(this.modifiers());
    };
    /**
   * Get a pagination object
   *
   * @returns {object}
   */ _proto.pagination = function pagination() {
        return Object.assign({}, {
            page: this.page,
            per_page: this.per_page
        });
    };
    /**
   * Get a pagination query
   *
   * @returns {string}
   */ _proto.paginationQuery = function paginationQuery() {
        return MagicBox.serialize(this.pagination());
    };
    /**
   * Turn a MagicBoxParams container into a query string
   *
   * @returns {string}
   */ _proto.toQuery = function toQuery() {
        var modQ = this.modifierQuery();
        if (!modQ) {
            return this.without_pagination ? "" : this.paginationQuery();
        }
        return this.without_pagination ? "".concat(modQ) : "".concat(modQ, "&").concat(this.paginationQuery());
    };
    /**
   * Set pagination options
   *
   * @param {number} page
   * @param {number} per_page
   * @returns {MagicBoxParams}
   */ _proto.setPagination = function setPagination(page, perPage) {
        this.page = page;
        this.per_page = perPage;
        return this;
    };
    /**
   * Set the filters object
   *
   * @param {object} filters
   * @returns {MagicBoxParams}
   */ _proto.setFilters = function setFilters(filters) {
        /** @TODO improve the typing of `filters`. */ // @ts-expect-error
        this.filters = filters;
        return this;
    };
    /**
   * Add a single filter
   *
   * @param {string} key
   * @param {string} value
   * @returns {MagicBoxParams}
   */ _proto.addFilter = function addFilter(key, value) {
        /** @TODO improve the typing of `filters`. */ // @ts-expect-error
        this.filters[key] = value;
        return this;
    };
    /**
   * Set the sort object
   *
   * @param {object} sort
   * @returns {MagicBoxParams}
   */ _proto.setSorts = function setSorts(sort) {
        /** @TODO improve the typing of `sort`. */ // @ts-expect-error
        this.sort = sort;
        return this;
    };
    /**
   * Add a single sort
   *
   * @param {string} key
   * @param {string} dir
   * @returns {MagicBoxParams}
   */ _proto.addSort = function addSort(key, dir) {
        /** @TODO improve the typing of `sort`. */ // @ts-expect-error
        this.sort[key] = dir;
        return this;
    };
    /**
   * Set the include object
   *
   * @param {string[]} include
   * @returns {MagicBoxParams}
   */ _proto.setIncludes = function setIncludes(include) {
        this.include = include;
        return this;
    };
    /**
   * Add a single include
   *
   * @param {string} include
   */ _proto.addInclude = function addInclude(include) {
        this.include.push(include);
    };
    /**
   * Ignore pagination
   */ _proto.withoutPagination = function withoutPagination() {
        this.without_pagination = true;
        return this;
    };
    return MagicBoxParams;
}(MagicContainer);



/***/ }),

/***/ 78914:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ dehydrate; },
/* harmony export */   "ZB": function() { return /* binding */ hydrate; }
/* harmony export */ });
/* unused harmony exports defaultShouldDehydrateMutation, defaultShouldDehydrateQuery */
// TYPES
// FUNCTIONS
function dehydrateMutation(mutation) {
  return {
    mutationKey: mutation.options.mutationKey,
    state: mutation.state
  };
} // Most config is not dehydrated but instead meant to configure again when
// consuming the de/rehydrated data, typically with useQuery on the client.
// Sometimes it might make sense to prefetch data on the server and include
// in the html-payload, but not consume it on the initial render.


function dehydrateQuery(query) {
  return {
    state: query.state,
    queryKey: query.queryKey,
    queryHash: query.queryHash
  };
}

function defaultShouldDehydrateMutation(mutation) {
  return mutation.state.isPaused;
}
function defaultShouldDehydrateQuery(query) {
  return query.state.status === 'success';
}
function dehydrate(client, options = {}) {
  const mutations = [];
  const queries = [];

  if (options.dehydrateMutations !== false) {
    const shouldDehydrateMutation = options.shouldDehydrateMutation || defaultShouldDehydrateMutation;
    client.getMutationCache().getAll().forEach(mutation => {
      if (shouldDehydrateMutation(mutation)) {
        mutations.push(dehydrateMutation(mutation));
      }
    });
  }

  if (options.dehydrateQueries !== false) {
    const shouldDehydrateQuery = options.shouldDehydrateQuery || defaultShouldDehydrateQuery;
    client.getQueryCache().getAll().forEach(query => {
      if (shouldDehydrateQuery(query)) {
        queries.push(dehydrateQuery(query));
      }
    });
  }

  return {
    mutations,
    queries
  };
}
function hydrate(client, dehydratedState, options) {
  if (typeof dehydratedState !== 'object' || dehydratedState === null) {
    return;
  }

  const mutationCache = client.getMutationCache();
  const queryCache = client.getQueryCache(); // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition

  const mutations = dehydratedState.mutations || []; // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition

  const queries = dehydratedState.queries || [];
  mutations.forEach(dehydratedMutation => {
    var _options$defaultOptio;

    mutationCache.build(client, { ...(options == null ? void 0 : (_options$defaultOptio = options.defaultOptions) == null ? void 0 : _options$defaultOptio.mutations),
      mutationKey: dehydratedMutation.mutationKey
    }, dehydratedMutation.state);
  });
  queries.forEach(dehydratedQuery => {
    var _options$defaultOptio2;

    const query = queryCache.get(dehydratedQuery.queryHash); // Reset fetch status to idle in the dehydrated state to avoid
    // query being stuck in fetching state upon hydration

    const dehydratedQueryState = { ...dehydratedQuery.state,
      fetchStatus: 'idle'
    }; // Do not hydrate if an existing query exists with newer data

    if (query) {
      if (query.state.dataUpdatedAt < dehydratedQueryState.dataUpdatedAt) {
        query.setState(dehydratedQueryState);
      }

      return;
    } // Restore query


    queryCache.build(client, { ...(options == null ? void 0 : (_options$defaultOptio2 = options.defaultOptions) == null ? void 0 : _options$defaultOptio2.queries),
      queryKey: dehydratedQuery.queryKey,
      queryHash: dehydratedQuery.queryHash
    }, dehydratedQueryState);
  });
}


//# sourceMappingURL=hydration.mjs.map


/***/ }),

/***/ 55464:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ Hydrate; }
/* harmony export */ });
/* unused harmony export useHydrate */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _tanstack_query_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78914);
/* harmony import */ var _QueryClientProvider_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55830);
'use client';




function useHydrate(state, options = {}) {
  const queryClient = (0,_QueryClientProvider_mjs__WEBPACK_IMPORTED_MODULE_1__/* .useQueryClient */ .NL)({
    context: options.context
  });
  const optionsRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(options);
  optionsRef.current = options; // Running hydrate again with the same queries is safe,
  // it wont overwrite or initialize existing queries,
  // relying on useMemo here is only a performance optimization.
  // hydrate can and should be run *during* render here for SSR to work properly

  react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    if (state) {
      (0,_tanstack_query_core__WEBPACK_IMPORTED_MODULE_2__/* .hydrate */ .ZB)(queryClient, state, optionsRef.current);
    }
  }, [queryClient, state]);
}
const Hydrate = ({
  children,
  options,
  state
}) => {
  useHydrate(state, options);
  return children;
};


//# sourceMappingURL=Hydrate.mjs.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [669,513,372,443,593,588,356,212,774,888,179], function() { return __webpack_exec__(68762); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);